<div class="container mt-4">
  <h2>{{ 'Debug' | translate }}</h2>
  <h3 class="h5">{{ 'Current User (UserService Signal)' | translate }}</h3>
  <pre class="bg-light p-3 border rounded">{{ user() | json }}</pre>
</div>
